import type { Table } from "common/data/table";
import { EMPTY_INSTANCE_OPTION_SETS } from "../doc/docDefaultConstants";
import type { DocOptionSet, InstanceOptionSet } from "./optionSet";

/**
 * Encapsulates the data needed to resolve option definitions.
 * This includes both the base option sets (archetypes) and the instance-specific option sets.
 *
 * This type is structurally satisfied by `Doc`, allowing many callers to pass the full document.
 */
export interface OptionDefinitions {
  readonly optionSets: Table<DocOptionSet>;
  readonly instanceOptionSets: Table<InstanceOptionSet>;
}

/**
 * Creates an `OptionDefinitions` object for paths that only have base option sets.
 */
export function archetypeOnlyOptions(optionSets: Table<DocOptionSet>): OptionDefinitions {
  return { optionSets, instanceOptionSets: EMPTY_INSTANCE_OPTION_SETS };
}

/**
 * Gets the instance-specific definition for an ID, if it exists.
 */
export function getInstanceOptionSet(
  definitions: OptionDefinitions,
  optionSetId: string,
): InstanceOptionSet | undefined {
  return definitions.instanceOptionSets[optionSetId];
}
